import moment from 'moment';

const GlobalMixins = {
  install(Vue) {
    Vue.mixin({
      methods: {
        imageUrl(image) {
          return `https://image.tmdb.org/t/p/w500/${image}`;
        },
        backdropUrl(image) {
          return `https://image.tmdb.org/t/p/original/${image}`;
        },
        profileImageUrl(image) {
          return `https://image.tmdb.org/t/p/w92/${image}`;
        },
        currencyFormatter(currency) {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
          }).format(currency);
        },
        getYear(date) {
          return moment(date).year();
        },
        formatMinute(time) {
          var hr = ~~((time % 3600) / 60);
          var min = ~~time % 60;

          return `${hr}h ${min}m`;
        },
        dateFormat(date) {
          return moment(date).format('DD MMM, YYYY');
        },
        commaList(lists) {
          return Array.from(lists).join(', ');
        },
      },
    });
  },
};

export default GlobalMixins;
